import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'components/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import HotelSection from './hotel-card';
import { TourListFormType } from '../form-type';
import { onAddNewHotel } from '../hooks/use-get-default-values';

export default function HotalTourSection() {
  const { t } = useTranslation();
  const { control, clearErrors } = useFormContext<TourListFormType>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tourHotels',
    keyName: '__customId',
  });

  const onAdd = React.useCallback(() => {
    append(onAddNewHotel());

    clearErrors();
  }, [append, clearErrors]);

  const onRemove = React.useCallback(
    (index) => {
      remove(index);
      clearErrors();
    },
    [clearErrors, remove],
  );

  const { editable } = useFormState();

  return (
    <div>
      {fields.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <HotelSection
            parentIndex={idx}
            onRemove={() => onRemove(idx)}
            fieldLength={fields.length}
          />
          <SeparatorVertical $margin={20}>
            <div style={{ height: 1, width: 4 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('common:hotel') })}
        </Button>
      )}
    </div>
  );
}
